import EcoNavProduct, { EcoNavProductProps } from 'eco-design/sections/eco-nav-product';
import { useRouter } from 'next/router';
import { productPageUrl, generalKeys } from '../../config/pageConfig';
import styles from './index.module.scss';
import { LangText } from './LangText';
import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { useGlobal } from '@/utils/useGlobal';
import { isStatusB } from '../../pages/product/pageStatus';

export default function ProductNav({ activeTab, tabCallback }: { activeTab: string; tabCallback?: any }) {
    const { gloproductlist } = useGlobal();

    const { locale = 'us', pathname } = useRouter();
    const TextA = LangText[locale] || LangText['us'];
    const thePageUrl = `/${locale}/${productPageUrl}`;
    const isInProductPage = pathname.endsWith(productPageUrl);

    let generalKey = generalKeys[0].key;
    if (locale === 'ph') {
        generalKey = generalKeys[2].key;
    }
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: generalKey });

    const buyLinkMap = {
        eu: 'https://eu.ecoflow.com/products/ecoflow-trail-series-dc-portable-power-station',
        uk: 'https://uk.ecoflow.com/products/ecoflow-trail-series-dc-portable-power-station',
        de: 'https://de.ecoflow.com/products/ecoflow-trail-series-dc-portable-power-station',
        fr: 'https://fr.ecoflow.com/products/ecoflow-trail-series-dc-portable-power-station',
        it: 'https://it.ecoflow.com/products/ecoflow-trail-series-dc-portable-power-station',
        es: 'https://es.ecoflow.com/products/ecoflow-trail-series-dc-portable-power-station',
        nl: 'https://nl.ecoflow.com/products/ecoflow-trail-series-dc-portable-power-station',
    };

    console.log(isStatusB());

    const dataA: EcoNavProductProps = {
        productItems: [
            {
                value: 'EcoFlow TRAIL Series DC',
                label: TextA.product_name,
                href: thePageUrl,
            },
        ],
        tabItems: [
            {
                value: 'Product',
                label: TextA.tab_product,
                href: isInProductPage ? undefined : thePageUrl,
            },
            ...(['us', 'ca'].includes(locale)
                ? [
                      {
                          value: 'Bundles',
                          label: TextA.tab_bundles,
                          href: isInProductPage ? undefined : `${thePageUrl}?tab=Bundles`,
                      },
                  ]
                : []),
            {
                value: 'Support',
                label: TextA.tab_support,
                href: `${thePageUrl}/support`,
            },
            {
                value: 'Specs',
                label: TextA.tab_specs,
                href: `${thePageUrl}/specs`,
            },
        ],
        buyItems: isStatusB()
            ? [
                  {
                      value: 'Button',
                      label: TextA.btn_buy,
                      href: ['us', 'ca', 'ph'].includes(locale) ? productMsg?.buyLink : buyLinkMap[locale as keyof typeof buyLinkMap],
                  },
              ]
            : [],
    };
    const tabChange = (item: any, index: number) => {
        if (tabCallback) {
            tabCallback(item.value);
        }
    };
    return (
        <div className={styles.comp}>
            <EcoNavProduct {...dataA} defaultTabActiveKey={activeTab} onTabChange={tabChange} />
        </div>
    );
}
